/***
 *
 *   LANDING INTEGRATIONS
 *   One flat logo row: the integrations that exist.
 *
 *   Two rounds of trimming got it here. It started as "project management"
 *   (Linear, Jira, Asana, ClickUp, Monday) and "communication" (Slack, Teams,
 *   Discord) — eight marks presented as if all eight worked. Two do:
 *   server/integrations only holds `clickup` (list + space import, ticket sync,
 *   webhooks) and `slack` (notifications), which is also all
 *   src/config/integrations.js wires up. The other six then spent a while under
 *   an "on the roadmap" heading, which is a feature queue the landing page has
 *   no reason to publish. They are gone; the "tell us what you need" line under
 *   the row carries that intent without committing to a list.
 *
 *   Anything added here must exist in BOTH server/integrations/<name>/ and
 *   src/config/integrations.js — that config is what actually puts the
 *   integration in front of a user.
 *
 *   MARKS. The design comp pulled these from Google's favicon service, which we
 *   will not do: the marketing page makes no third-party requests. They used to
 *   be monogram tiles ("C", "S") for want of a local asset, but there was one
 *   all along. public/assets/{clickup,slack}-logo.png are wordmarks, and each
 *   one leads with its brand mark, so the marks in public/assets/integrations/
 *   are cropped straight out of them: genuine full-colour artwork, no
 *   reconstruction, still no third-party request.
 *
 **********/

import { useTranslate } from 'app/translations';
import Shared from './landing.tailwind.js';
import Style from './integrations.tailwind.js';

const ITEMS = [
    { name: 'ClickUp', logo: '/assets/integrations/clickup.png' },
    { name: 'Slack', logo: '/assets/integrations/slack.png' },
];

export function LandingIntegrations(props) {
    const { _t } = useTranslate();

    return (
        <section id="integrations" className={Shared.section}>
            <div className={Shared.container}>
                <div className={Shared.eyebrow}>{_t('landing.integrations.eyebrow')}</div>
                <h2 className={Shared.title}>{_t('landing.integrations.title')}</h2>
                <p className={Style.lede}>{_t('landing.integrations.lede')}</p>

                <div className={Style.grid}>
                    {ITEMS.map((item) => (
                        <div key={item.name} className={Style.card}>
                            {/* alt="" — the name sits right beside it */}
                            <img src={item.logo} alt="" className={Style.logo} />
                            <span className={Style.name}>{item.name}</span>
                        </div>
                    ))}
                </div>

                <p className={Style.more}>
                    {_t('landing.integrations.more')}{' '}
                    <a href="#contact" className="text-primary-600 hover:text-primary-700">
                        {_t('landing.integrations.moreLink')}
                    </a>
                    .
                </p>
            </div>
        </section>
    );
}
